// Function loadReadingTab loads the ReadingTab class by dynamically importing the js on demand if needed

export function loadReadingTab($parentEl, isList = false) {

	let $wg = $parentEl.querySelector('[data-wg="ReadingTab"]');

	if(!$wg) {
		// console.info('ReadingTab: no widget found');
		return Promise.reject('ReadingTab widget not found in the parent element');
	}

	return import(/* webpackChunkName: "wg-reading-tab-chunk" */ '../widgets/readingTab').then(wg => {

		const { ReadingTab } = wg;

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ReadingTab"]');
			let instances = [];
			Array.from($wgCol).forEach(($wg, i) => {
				instances.push( new ReadingTab($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ReadingTab($wg);
		}


	}).catch(error => error+'An error occurred while loading the ReadingTab widget');

}
